import { DealRoom } from 'models/DealRoom';
import { ObjectValues } from 'types';

export type PortfolioSellerTable = Pick<
  DealRoom,
  | 'listing'
  | 'stage'
  | 'listingStage'
  | 'buyersSort'
  | 'filesSort'
  | 'lastUpdated'
  | 'industry'
  | 'location'
  | 'ownerName'
  | 'companyName'
> &
  Record<
    'commission' | 'manage' | 'price' | 'leadBrokerName' | 'coBrokerName',
    string
  >;

export type PortfolioSellerTableKeys = Array<keyof PortfolioSellerTable>;

export const TABLE_COLUMNS: Partial<PortfolioSellerTableKeys> = [
  'listing',
  'stage',
  'listingStage',
  'price',
  'commission',
  'buyersSort',
  'filesSort',
  'location',
  'ownerName',
  'leadBrokerName',
  'companyName',
  'lastUpdated',
  'industry',
];

export const BOSS_MODE_TABLE_COLUMNS: Partial<PortfolioSellerTableKeys> = [
  ...TABLE_COLUMNS,
  'manage',
];

export const ENTERPRISE_TABLE_COLUMNS: Partial<PortfolioSellerTableKeys> = [
  'listing',
  'stage',
  'listingStage',
  'price',
  'commission',
  'ownerName',
  'leadBrokerName',
  'coBrokerName',
  'filesSort',
  'buyersSort',
  'location',
  'lastUpdated',
  'industry',
  'manage',
];

type TableColumnsMap = Partial<Record<typeof TABLE_COLUMNS[number], string>>;

export const BASE_HEADING_TRANSLATIONS: TableColumnsMap = {
  listing: 'deal',
  stage: 'stage',
  commission: 'comm',
  listingStage: 'listing',
  filesSort: 'files',
  buyersSort: 'leads',
  lastUpdated: 'lastActivity',
  ownerName: 'owner',
  industry: 'industry',
  location: 'location',
  companyName: 'firm',
  manage: '',
  price: 'EV',
};

export const HEADING_TRANSLATIONS: TableColumnsMap = {
  ...BASE_HEADING_TRANSLATIONS,
  leadBrokerName: 'leadBroker',
  coBrokerName: 'coBroker',
};

export const LCW_HEADING_TRANSLATIONS: TableColumnsMap = {
  ...BASE_HEADING_TRANSLATIONS,
  leadBrokerName: 'agent',
  coBrokerName: 'co_agent',
};

export const SORTING_VALUES: TableColumnsMap = {
  listing: 'sortName',
  stage: 'stage',
  listingStage: 'listingStageSort',
  lastUpdated: 'lastUpdated',
  industry: 'industry',
  price: 'priceSort',
  commission: 'franchisorFeePercentage',
  filesSort: 'filesSort',
  buyersSort: 'buyersSort',
  location: 'location',
};

export type SortingValues = ObjectValues<typeof SORTING_VALUES>;

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  listing: 350,
  stage: 150,
  listingStage: 150,
  location: 100,
  buyersSort: 50,
  filesSort: 50,
  industry: 200,
  commission: 100,
  manage: 50,
};

export const REQUIRED_COLUMNS = ['listing'];
